import React, { useState, useEffect } from 'react';
import Container from '@material-ui/core/Container';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';

import Inventories from './Inventories';
import Orders from './Orders';
import { auth, db } from './Firebase/firebase';
import logo from './assets/usku_logo.png';
import './business.css';
import HelpButton from './HelpButton';

const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      position: 'relative'
    },
    title: {
      flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
    },
    button: {
        margin: theme.spacing(3),
    },
    fab: {
        position: 'absolute',
        bottom: theme.spacing(2),
        right: theme.spacing(2),
    },
}));

function BusinessPortal() {

    const classes = useStyles();

    const [portalState, setPortalState] = useState("logout");
    const [formInfo, setFormInfo] = useState({});
    const [error, setError] = useState(null);
    const [updateError, setUpdateError] = useState(null);
    const [updateStatus, setUpdateStatus] = useState(null);
    const [user, setUser] = useState(null);
    const [userInfo, setUserInfo] = useState(null);
    const [hasCode, setHasCode] = useState(false);
    const [signUpError, setSignUpError] = useState(null);
    const [signUpFormInfo, setSignUpFormInfo] = useState({});
    const [signUpStatus, setSignUpStatus] = useState(null);
    const [pageTitle, setPageTitle] = useState('details');

    useEffect(() => {
        const authListener = auth.onAuthStateChanged((authUser) => {
            if (authUser) {
                db.collection('business').doc(authUser.email).get()
                    .then((doc) => {
                        if (doc.exists) {
                            setUser(authUser);
                            setUserInfo(doc.data());
                            setPortalState("login");
                            setError(null);
                            if (doc.data().businessCode !== "") {
                                setHasCode(true);
                            }
                        } else {
                            setError("This account has no access permission");
                            auth.signOut();
                            setUser(null);
                            setUserInfo(null);
                        }
                    })
            } else {
                setUser(null);
                setPortalState("logout");
            }
        });
          return authListener;
    }, [])

    function logIn(e) {
        e.persist();
        const { email, password } = formInfo;
        setError(null);

        if (email === "" || password === "" || email === undefined || password === undefined) {
            setError("Email and Password cannot be empty");
            return
        }

        auth.signInWithEmailAndPassword(email, password)
            .catch((e) => {
                console.log(e);
                setError(e.message);
            })
    }

    function handleLoginChange(e) {
        e.persist();
        setFormInfo(formInfo => ({...formInfo, [e.target.name]: e.target.value}));
    }

    function handleUserInfoChange(e) {
        e.persist();
        setUserInfo(userInfo => ({...userInfo, [e.target.name]: e.target.value}));
    }

    function handleSignUpChange(e) {
        e.persist();
        setSignUpFormInfo(signUpFormInfo => ({...signUpFormInfo, [e.target.name]: e.target.value}))
    }

    function signUp(e) {
        setSignUpError(null);
        setSignUpStatus(null);
        e.persist();

        const { email, password, confirmPassword } = signUpFormInfo;

        if (email === "" || password === "" || email === undefined || password === undefined || confirmPassword === "" || confirmPassword === undefined) {
            setSignUpError("Email, Password and Confirm Password cannot be empty");
            return
        }

        if (password !== confirmPassword) {
            setSignUpError("Password and confirmPassword not match");
            return
        }

        // sign up with firebase auth
        auth.createUserWithEmailAndPassword(email, password)
            .then(() => {
                try {
                    db.collection("business").doc(email).set({
                        abn: "",
                        businessCode: "",
                        businessDesc: "",
                        businessName: "",
                        businessPhone: "",
                        category: "",
                        city: "",
                        featuredImages: [],
                        itemsSold: [],
                        ordersReceived: [],
                        inventories: [],
                        logo: "",
                        name: "",
                        no: "",
                        phone: "",
                        postcode: "",
                        profileType: "normal",
                        street: "",
                        stripe_id: "",
                        tnc: "",
                        website: "",
                        expired: false,
                        status: "inactive",
                        isVendor: false,
                        bankName: "",
                        bankAccountName: "",
                        bankAccountNo: "",
                        bankAccountBSB: "",
                    }).then(() => {
                        setSignUpStatus("Your account has been created. Please proceed with sign in");
                    })

                } catch (e) {
                    setSignUpError(e.message);
                }
            })
            .catch((e) => {
                setSignUpError(e.message);
            })

    }

    function logOut(e) {
        e.persist();

        auth.signOut();
        setUser(null);
        setUserInfo(null);
        setFormInfo({});
        setPortalState("logout");
    }

    function updateInformation(e) {
        e.persist();
        setUpdateError(null);
        setUpdateStatus(null);

        if (hasCode) {
            try {
                db.collection("business").doc(user.email)
                    .set(userInfo)
                    .then(() => {
                        setUpdateStatus("Update Successful");
                    })
            } catch (e) {
                setUpdateError(e.message);
            }
        } else {
            try {
                db.collection("business_code").doc(userInfo.businessCode)
                    .get()
                    .then((doc) => {
                        if (doc.exists) {
                            setUpdateError("Business Code already taken");
                            return
                        } else {
                            db.collection("business").doc(user.email)
                                .set(userInfo);
    
                            db.collection("business_code").doc(userInfo.businessCode)
                                .set({
                                    email: user.email
                                }).then(() => {
                                   setUpdateStatus("Update Successful");
                                   setHasCode(true);
                                })
                        }
                    })
            } catch (e) {
                console.log(e.message);
            }
        }
    }

    if (portalState === "logout") {
        return(
            <div>
                <div className="form">
                    <div className="form-container">
                    <img className="usku-logo" src={logo} alt="Usku" />
                    <h1>Usku Business Portal</h1>
                    <br/>
                    <form id="material-form" className={classes.root} noValidate autoComplete="off">
                        <Grid container spacing={4}>
                            <Grid item xs={12}>
                                <TextField id="outlined-basic" label="Email Address" variant="outlined" name="email" onChange={handleLoginChange} fullWidth={true} />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField id="outlined-basic" label="Password" type="password" variant="outlined" name="password" onChange={handleLoginChange} fullWidth={true} />
                            </Grid>
                        </Grid>
                    </form>
                    <br/>
                    {error === null ? <p></p> : <p style={{textAlign: "center", color: "red"}}>{error}</p>}
                    <div style={{textAlign: "center"}}>
                        <Button style={{backgroundColor: "orange", color: "black"}} onClick={logIn}>Log In</Button>
                    </div>
                    <br/>
                    <div style={{textAlign: "center"}}>
                        <a href="" style={{ textDecoration: "none" }} onClick={(e) => {e.preventDefault(); setPortalState("signup")}}>Register your business with Usku</a>
                    </div>
                    </div>
                </div>
            </div>
        )
    } else if (portalState === "signup") {
        return (
            <div>
                <div className="form">
                    <div className="form-container">
                    <img className="usku-logo" src={logo} alt="Usku" />
                    <h1>Usku Business Registration</h1>
                    <br/>
                    <form id="material-form" className={classes.root} noValidate autoComplete="off">
                        <Grid container spacing={4}>
                            <Grid item xs={12}>
                                <TextField id="outlined-basic" label="Email Address" variant="outlined" name="email" onChange={handleSignUpChange} fullWidth={true} />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField id="outlined-basic" label="Password" type="password" variant="outlined" name="password" onChange={handleSignUpChange} fullWidth={true} />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField id="outlined-basic" label="Confirm Password" type="password" variant="outlined" name="confirmPassword" onChange={handleSignUpChange} fullWidth={true} />
                            </Grid>
                        </Grid>
                    </form>
                    <br/>
                    {signUpError === null ? <p></p> : <p style={{textAlign: "center", color: "red"}}>{signUpError}</p>}
                    {signUpStatus === null ? <p></p> : <p style={{textAlign: "center", color: "green"}}>{signUpStatus}</p>}
                    <div style={{textAlign: "center"}}>
                        <Button style={{backgroundColor: "orange", color: "black"}} onClick={signUp}>Sign Up</Button>
                    </div>
                    <br/>
                    <div style={{textAlign: "center"}}>
                        <a href="" style={{ textDecoration: "none" }} onClick={(e) => {e.preventDefault(); setPortalState("logout")}}>Have an account? Login Instead</a>
                    </div>
                    <br/><br/>
                    </div>
                </div>
            </div>
        )
    } else {
        return(
            <div className={classes.root}>
                <AppBar position="static">
                    <Toolbar>
                        <Typography variant="h6" className={classes.title}>Usku Technologies</Typography>
                        <Button style={{backgroundColor: "orange", color: "black"}} onClick={logOut}>Log Out</Button>
                    </Toolbar>
                </AppBar>
                <Container>
                    <h1 style={{textAlign: "center"}}>Business Portal</h1>
                    {(user && userInfo.status === "inactive" ) && 
                        <h2>{user.email} - <span style={{textTransform: "uppercase", color: "red"}}>{userInfo.status}</span></h2>
                    }
                    {(user && userInfo.status === "active" ) && 
                        <h2>{user.email} - <span style={{textTransform: "uppercase", color: "green"}}>{userInfo.status}</span></h2>
                    }
                    <Typography variant="p">Please use the link at the bottom left of the page to access the management portal for now</Typography>
                    <br />
                    <Button 
                        variant="contained" 
                        color="primary" 
                        className={classes.button}
                        onClick={() => setPageTitle("details")}
                    >
                        Details
                    </Button>
                    {userInfo && userInfo.isVendor && 
                        <>
                            <Button 
                                disabled={true}
                                variant="contained" 
                                color="primary" 
                                className={classes.button}
                                onClick={() => setPageTitle("inventories")}
                            >
                                Inventories
                            </Button>   
                            <Button 
                                disabled={true}
                                variant="contained" 
                                color="primary" 
                                className={classes.button}
                                onClick={() => setPageTitle("orders")}
                            >
                                Orders
                            </Button>       
                        </>              
                    }
                    {pageTitle === 'details' &&
                    <>
                        <form id="material-form" className={classes.root} noValidate autoComplete="off">
                            <Grid container spacing={4}>
                                <Grid item xs={12}>
                                    <TextField id="outlined-basic" label="Business Code" variant="outlined" name="businessCode" disabled={hasCode} onChange={handleUserInfoChange} fullWidth={true} value={userInfo.businessCode} />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField id="outlined-basic" label="Contact Name" variant="outlined" name="name" onChange={handleUserInfoChange} fullWidth={true} value={userInfo.name} />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField id="outlined-basic" label="Phone Number" variant="outlined" name="phone" onChange={handleUserInfoChange} fullWidth={true} value={userInfo.phone} />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField id="outlined-basic" label="Business Name" variant="outlined" name="businessName" onChange={handleUserInfoChange} fullWidth={true} value={userInfo.businessName} />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField id="outlined-basic" label="Business Phone" variant="outlined" name="businessPhone" onChange={handleUserInfoChange} fullWidth={true} value={userInfo.businessPhone} />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField id="outlined-basic" label="Business Website" variant="outlined" name="website" onChange={handleUserInfoChange} fullWidth={true} value={userInfo.website} />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField id="outlined-basic" label="Business Category" variant="outlined" name="category" onChange={handleUserInfoChange} fullWidth={true} value={userInfo.category} />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField id="outlined-basic" label="Business Description" variant="outlined" name="businessDesc" onChange={handleUserInfoChange} fullWidth={true} value={userInfo.businessDesc}  
                                        multiline
                                        rows={2}
                                        rowsMax={4} 
                                    />                            
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField id="outlined-basic" label="No" variant="outlined" name="no" onChange={handleUserInfoChange} fullWidth={true} value={userInfo.no} />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField id="outlined-basic" label="Street" variant="outlined" name="street" onChange={handleUserInfoChange} fullWidth={true} value={userInfo.street} />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField id="outlined-basic" label="Postcode" variant="outlined" name="postcode" onChange={handleUserInfoChange} fullWidth={true} value={userInfo.postcode} />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField id="outlined-basic" label="City" variant="outlined" name="city" onChange={handleUserInfoChange} fullWidth={true} value={userInfo.city} />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField id="outlined-basic" label="Bank Name" variant="outlined" name="bankName" onChange={handleUserInfoChange} fullWidth={true} value={userInfo.bankName} />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField id="outlined-basic" label="Account Name" variant="outlined" name="bankAccountName" onChange={handleUserInfoChange} fullWidth={true} value={userInfo.bankAccountName} />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField id="outlined-basic" label="Account No." variant="outlined" name="bankAccountNo" onChange={handleUserInfoChange} fullWidth={true} value={userInfo.bankAccountNo} />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField id="outlined-basic" label="BSB" variant="outlined" name="bankAccountBSB" onChange={handleUserInfoChange} fullWidth={true} value={userInfo.bankAccountBSB} />
                                </Grid>
                            </Grid>
                        </form>
                        <br/>
                        {(hasCode && userInfo.status === "active") &&  
                        <div>
                        <hr/>
                        <br/>
                        <Grid container spacing={4}>
                            <Grid item xs={12} md={6}>
                                <h3>Use the built-in button in your website</h3>
                                <ol>
                                    <li>Copy the given code</li>
                                    <li>Paste in your website</li>
                                    <li>Alternatively, you can use this link if you want to <br/> create your own button or link it to some other external components</li>
                                </ol>
                                <a href={`https://usku-delivery.web.app/enterprise?code=${userInfo.businessCode}`}>https://usku-delivery.web.app/enterprise?code={userInfo.businessCode}</a>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <br/>
                                <TextField id="outlined-basic" label="Iframe Code" variant="outlined" fullWidth={true}
                                    value={`<div style="cursor: pointer; width: 280px;" onclick="window.location='https://usku-delivery.web.app/enterprise?code=` + userInfo.businessCode + `';"><div style="background-color: rgba(204, 204, 204, 0.2); padding: 8px 4px; width: 270px; height: 50px; border: 1px solid rgb(204, 204, 204); border-radius: 15px;"><div style="width: 20%; float: left"><img src="https://uskutech.com/wp-content/uploads/elementor/thumbs/cropped-honeycombwhite-os9rfnr8ku85pc349p387hw62sh7avt5r8jozkdmd0.png" alt="logo" /></div><div style="width: 80%; float: left"><span style="font-size: 24px; font-weight: bold;">Order with Usku!</span><br /><span style="font-size: 12px;">Delivery Straight to Your Door</span></div></div></div>`}
                                    disabled
                                    multiline
                                    rows={15}
                                    rowsMax={20}
                                    />                            
                            </Grid>
                        </Grid>
                        </div>
                        }
                        <br/><br/>
                        <div style={{textAlign: "center"}}>
                            {updateError === null ? <p></p> : <p style={{textAlign: "center", color: "red"}}>{updateError}</p>}
                        </div>
                        <div style={{textAlign: "center"}}>
                            {updateStatus === null ? <p></p> : <p style={{textAlign: "center", color: "green"}}>{updateStatus}</p>}
                        </div>
                        <div style={{textAlign: "center"}}>
                            <Button style={{backgroundColor: "orange", color: "black"}} onClick={updateInformation}>Update Information</Button>
                        </div>   
                    </>                 
                    }
                    {pageTitle === "inventories" &&
                        <Inventories userInfo={userInfo} email={user.email}/>
                    }
                    {pageTitle === "orders" &&
                        <Orders businessId={user.email} />
                    }
                    <a href="https://usku.com.au/vendor-login/">Enterprise Portal</a>
                </Container>  
                <HelpButton />         
                <br/><br/>
            </div>
        )
    }
}

export default BusinessPortal;